import React, { useState, useEffect } from 'react';
import { CourseClassroomPlayerYoutube } from './course-classroom-player-youtube';
import { CourseClassroomPlayerVimeo } from './course-classroom-player-vimeo';
import { useClient } from 'jsonapi-react';
import useAuthorityLevel from '@/hooks/useAuthorityLevel';
import { CourseClassroomExamEmpty } from './course-classroom-exam-empty';
import { CourseClassroomExamDisapproved } from './course-classroom-exam-disapproved';
import { ClassroomPlayer, ClassroomPlayerFrame } from '@/components/custom/classroom';

export function CourseClassroomPlayer(props) {
  const {
    disclaimerModal,
    setFinishVideoModal,
    unfinishedExam,
    url,
    learnSystemUseItem,
    setLearnSystemUseItem,
    setUpdateContentNow,
    selectedItem,
    updateLearnSystemContents,
    showQuizModal,
    setShowQuizModal,
    setCurrentQuiz,
    checkLearnSystemUseItem,
    unansweredQuestions
  } = props;
  const [player, setPlayer] = useState();
  const [videoId, setVideoId] = useState();
  const [intervalId, setIntervalId] = useState();

  const client = useClient();
  const authorityLevel = useAuthorityLevel();

  const isStudent = authorityLevel === 'student';

  useEffect(() => {
    if (url) checkVideoPlayer(url);
  }, [url]);

  const onUpdateProgress = async percent => {
    if (isStudent && (percent >= learnSystemUseItem.percent || !learnSystemUseItem?.finished)) {
      const params =
        percent >= learnSystemUseItem?.percent
          ? {
              percent
            }
          : {};

      const { data } = await client.mutate(['learning_system_user_items', learnSystemUseItem?.id], params);
      setLearnSystemUseItem(data);
      if (data.finished) {
        updateLearnSystemContents(data);
      }
    }
  };

  const checkVideoPlayer = url => {
    const youtubeRegex = /^((?:https?:)?\/\/)?((?:www|m)\.)?((?:youtube(-nocookie)?\.com|youtu.be))(\/(?:[\w\-]+\?v?=|embed\/|v\/|live\/)?)([\w\-]+)(\S+)?$/;
    const vimeoRegex = /(http|https)?:\/\/(www\.|player\.)?vimeo\.com\/(?:channels\/(?:\w+\/)?|groups\/([^\/]*)\/videos\/|video\/|)(\d+)(?:|\/\?)/;

    const youtubeResult = url.match(youtubeRegex);
    if (youtubeResult) {
      clearInterval(intervalId);
      setPlayer(null);
      setTimeout(() => setPlayer('youtube'), 500);
      setVideoId(youtubeResult[6]);
      return;
    }

    const vimeoResult = url.match(vimeoRegex);
    if (vimeoResult) {
      clearInterval(intervalId);
      setPlayer(null);
      setTimeout(() => setPlayer('vimeo'), 500);
      setVideoId(vimeoResult[4]);
    }
  };

  return (
    <ClassroomPlayer className="animate-fade-in">
      {unfinishedExam === undefined ? (
        <ClassroomPlayerFrame>
          {player && player === 'youtube' && (
            <CourseClassroomPlayerYoutube
              disclaimerModal={disclaimerModal}
              setFinishVideoModal={setFinishVideoModal}
              unansweredQuestions={unansweredQuestions}
              setCurrentQuiz={setCurrentQuiz}
              selectedItem={selectedItem}
              showQuizModal={showQuizModal}
              setShowQuizModal={setShowQuizModal}
              videoId={videoId}
              intervalId={intervalId}
              setIntervalId={setIntervalId}
              onUpdateProgress={onUpdateProgress}
              setUpdateContentNow={setUpdateContentNow}
            />
          )}
          {player && player === 'vimeo' && (
            <CourseClassroomPlayerVimeo
              disclaimerModal={disclaimerModal}
              setFinishVideoModal={setFinishVideoModal}
              unansweredQuestions={unansweredQuestions}
              setCurrentQuiz={setCurrentQuiz}
              selectedItem={selectedItem}
              showQuizModal={showQuizModal}
              setShowQuizModal={setShowQuizModal}
              videoId={videoId}
              intervalId={intervalId}
              setIntervalId={setIntervalId}
              onUpdateProgress={onUpdateProgress}
              setUpdateContentNow={setUpdateContentNow}
              onFetchLearnSystemUserItem={checkLearnSystemUseItem}
            />
          )}
          {player !== 'youtube' && player !== 'vimeo' && <iframe src={url?.replace('view?usp=share_link', 'preview')}></iframe>}
        </ClassroomPlayerFrame>
      ) : unfinishedExam?.['question-book-user-ids']?.length > 0 ? (
        <CourseClassroomExamDisapproved unfinishedExam={unfinishedExam} />
      ) : (
        <CourseClassroomExamEmpty unfinishedExam={unfinishedExam} />
      )}
    </ClassroomPlayer>
  );
}
